<template>
  <div :class="$style.root">
    <div :class="$style.title" :data-overflow-hidden="titleOneLine ? '' : null">
      {{ attributes?.title }}
      <span v-if="includeLabel" :class="$style.label">
        {{ $t('pages.press.kit.label', { count: 0 })?.toLowerCase() }}
      </span>
    </div>

    <CoreDownloadsComponent :downloads="attributes?.files?.data" />
    <SharedPressRelationComponent
      v-if="includeRelation"
      :attributes="attributes"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
  includeLabel: {
    type: Boolean,
    default: false,
  },
  titleOneLine: {
    type: Boolean,
    default: false,
  },
  includeRelation: {
    type: Boolean,
    default: true,
  }
})

const getAttributes = baseStrapiGetAttributes
const localizedData = baseStrapiGetLocalizedData(props.data)
const attributes = baseStrapiGetAttributes(localizedData)
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
}

.title {
  composes: font-size-default from global;
}

.title[data-overflow-hidden] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  line-height: 1;
  padding-top: .2em;
}

.label {
  composes: font-size-small font-helvetica label-inverted from global;
  align-self: flex-start;
}
</style>
